import type { AdvertiserDto } from '@/services/ws-selfbooking/src/main/resources/rest-api';

import { formatIndustryOptionLabel } from 'src/hooks/useIndustryLocalizedOptions';
import type { Option } from 'src/types';

export const selectedFilterOptions = <T>(allOptions: Option<T>[], selectedIds?: T[]): Option<T>[] =>
  selectedIds ? allOptions.filter((option) => selectedIds.includes(option.value)) : [];

export const formatSelfBookingAdvertiserOptionLabel = (advertiser: AdvertiserDto, language: string) =>
  `${advertiser.name} (${formatIndustryOptionLabel(advertiser.industry, language)})`;
